import React from 'react';

export const Blog = ({ data }) => {
  if (!data) return null;

  return (
    <section id="blog">
      <div className="container">
        <div className="section-title">
          <span className="section-label">Insights</span>
          <h2>From Our Blog</h2>
          <p>
            Thoughts on product building, technology, and the industries we
            work in.
          </p>
        </div>

        <div className="row">
          {data.map((post, index) => (
            <div key={index} className="col-md-4">
              <div className="blog-card">
                <span className="blog-tag">{post.tag}</span>
                <div className="blog-title">{post.title}</div>
                <p className="blog-excerpt">{post.excerpt}</p>
                <div className="blog-meta">{post.date}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
